import { Link } from 'react-router-dom';

const KANIT = { fontFamily: "'Kanit', system-ui, sans-serif" };

export const PanthersStrip = () => (
  <Link
    to="/panthers-partnership"
    className="flex items-center justify-center gap-3 bg-white border-b border-[#EAEFF4] px-4 py-3 group"
    data-testid="panthers-strip"
    aria-label="KGOB is a Carolina Panthers Small Business Partner for 2026. About the partnership."
  >
    <img
      src="/brand/panthers/panthers-sbp-white.jpg"
      alt="Carolina Panthers Small Business Partner 2026"
      className="h-[42px] w-auto object-contain flex-shrink-0"
    />
    <span className="w-px self-stretch bg-[#E4E9EF]" aria-hidden="true" />
    <span className="flex flex-col gap-0.5" style={KANIT}>
      <span className="text-[13px] font-semibold leading-tight text-[#002C6B]">
        We've teamed up with the Carolina Panthers
      </span>
      <span className="text-[12px] font-semibold leading-tight text-[#0085CA] transition-colors group-hover:text-[#002C6B]">
        About the 2026 partnership →
      </span>
    </span>
  </Link>
);
